import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useFormContext } from 'react-hook-form';
import TextInput from '@widgets/shared/components/form-controls/TextInput';
import { createRef, useState } from 'react';
import API from '@widgets/shared/API/connection';
import { loginAction } from '@widgets/shared/registerOrLoginAction';
import { Wrapper } from './styles';
function ParentForm(props) {
    const ref = createRef();
    const [isRequesting, setIsRequesting] = useState(false);
    const { successUrl, loginTitle, registerLink, registerCopy, loginHeadingSize, onHandleForgotPassword, forgotPasswordLink, onHandleChildren, onHandleError, useLocalSuccessUrl, loginAction: loginActionOverride, } = props;
    const form = useFormContext();
    const { formState: { isValid }, handleSubmit, getValues, setError, } = form;
    const handleSubmitEvent = () => {
        setIsRequesting(true);
        const values = getValues();
        const formEl = ref.current;
        API.login(values).then((res) => {
            const maybeChildren = loginAction(res, formEl, () => { }, (errors, message) => {
                errors.forEach((error) => {
                    if (error.field) {
                        setError(error.field, { message: error.message }, { shouldFocus: true });
                    }
                    if (message) {
                        onHandleError(message);
                    }
                });
            }, successUrl, useLocalSuccessUrl, loginActionOverride);
            // if there are no children then we need to redirect here
            // if (!maybeChildren) {
            //   onHandleSuccess(res);
            // }
            onHandleChildren(maybeChildren ?? []);
        }).finally(() => {
            setIsRequesting(false);
        });
    };
    return (_jsx(Wrapper, { children: _jsxs("form", { method: "POST", ref: ref, onSubmit: handleSubmit(handleSubmitEvent), noValidate: true, className: "form form--login", children: [_jsx("div", { className: "form__content content-block", children: _jsx("h2", { className: loginHeadingSize ?? 'h4', children: loginTitle ?? 'Please Log in' }) }), _jsx(TextInput, { inputAttrs: { id: 'email-field', name: 'email', type: 'email' }, labelAttrs: {
                        htmlFor: 'email-field',
                        text: 'Email Address',
                        isFieldRequired: false, // it is but hiding the asterix
                    } }), _jsxs("div", { className: "form__password", children: [_jsxs("div", { className: "form__forgot-password form__label", children: [_jsx("span", { className: "", children: "Password" }), onHandleForgotPassword && (_jsx("button", { className: "link-btn", type: "button", onClick: onHandleForgotPassword, children: "Forgot Password?" })), !onHandleForgotPassword && (_jsx("a", { href: forgotPasswordLink ?? '/forgot-password.html', children: "Forgot Password?" }))] }), _jsx(TextInput, { inputAttrs: {
                                id: 'password-field',
                                name: 'password',
                                type: 'password',
                                required: true,
                            }, labelAttrs: {
                                htmlFor: 'password-field',
                                isFieldRequired: true,
                                text: 'Password',
                                hidden: true,
                            } })] }), _jsxs("div", { className: "form__actions", children: [_jsx("button", { type: "submit", className: "btn", disabled: !isValid || isRequesting, children: "Login" }), (registerCopy && registerLink) && (_jsx("a", { className: "form__link", href: registerLink, children: registerCopy }))] })] }) }));
}
export default ParentForm;
